
import SvgIcon from "Theme/SvgIcon"
import { ReactComponent as ArticlesIcon } from "../fontello/icons/svg/ic_articles.svg"


const Articles = ({ ...props }) => (
  <SvgIcon
    component={ArticlesIcon}
    viewBox="0 0 1000 1000"
    {...props}
  />
)


export default Articles
